import { useContext, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { AppContext } from "../App";

const WhatsAppButton = () => {
  const { settings } = useContext(AppContext);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  
  const whatsappNumber = settings?.whatsapp?.replace(/\s/g, "") || "+436641234567";
  const whatsappLink = `https://wa.me/${whatsappNumber.replace("+", "")}?text=${encodeURIComponent("Hallo, ich interessiere mich für einen Termin bei Monaco Bar.")}`;

  return (
    <div className="fixed bottom-20 right-4 z-40 sm:bottom-6 sm:right-6 lg:bottom-8 lg:right-8" data-testid="whatsapp-button">
      {/* Tooltip */}
      {isTooltipVisible && (
        <div className="absolute bottom-16 right-0 bg-monaco-bg-1 border border-white/10 rounded-xl p-4 shadow-lg w-64 animate-fade-in">
          <button 
            onClick={() => setIsTooltipVisible(false)}
            className="absolute top-2 right-2 text-monaco-text-2 hover:text-monaco-text-0"
          >
            <X className="w-4 h-4" />
          </button>
          <p className="text-sm text-monaco-text-0 mb-3 pr-4">
            Direkter Kontakt via WhatsApp
          </p>
          <p className="text-xs text-monaco-text-2">
            Diskreter Service • Schnelle Antwort
          </p>
        </div>
      )}
      
      {/* Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 hover:shadow-[0_0_20px_rgba(37,211,102,0.4)] transition-all duration-300"
        aria-label="WhatsApp Kontakt"
      >
        <MessageCircle className="w-7 h-7" fill="currentColor" />
      </a>
      
      {/* Pulse Animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 pointer-events-none" />
    </div>
  );
};

export default WhatsAppButton;
